import React, { useState, useEffect } from "react";
import Select from "react-select";
import { checkIfArray, checkIfObjectHasKeys } from "../../../util/checking";

const find_OP = (obj) => {
	switch (obj.operation_status) {
		case 2:
			return "#ff8500";
		default:
			return "black"	
	}
};

const selectStyles = {
	option: (provided, state) => ({
		...provided,
		color: state.isSelected ? "white" : find_OP(state.data),
		fontSize: "13px",
	}),
	groupHeading: (provided, state) => ({
		...provided,
		fontSize: "13px",
		color: "#a4aaaa",
		borderTop: "#a4aaaa 1px solid",
	}),
	container: (provided, state) => ({
		...provided,
		width: "100%",
		display: "inline-block",
	}),
	valueContainer: (provided, state) => ({
		...provided,
		height: "38px",
	}),
	singleValue: (provided, state) => ({
		...provided,
		paddingLeft: "8px",
		paddingRight: "8px",
	}),
	placeholder: (provided, state) => ({
		...provided,
		fontSize: "1em",
		fontWeight: 400,
	}),
	singleValue: (provided, state) => {
		const transition = "opacity 300ms";
		return { ...provided, transition };
	},
	menuList: (provided) => ({
		...provided,
		zIndex: 999,
		maxHeight: "200px",
		border: "1px solid rgb(204, 204, 204)",
		borderRadius: "4px",
	}),
};

export const NormalSelect = (props) => {
	const [val, setVal] = useState(null);
	const [list, setList] = useState([]);

	const [isReady, setReady] = useState(false);

	const handleChange = (e) => {
		if (checkIfObjectHasKeys(e)) {
			if (e.value !== null || e.value !== undefined) {
				setVal(e);
				props.onChange(e);
			} 
		}
	};

	const filterOption = ({ label, value }, string) => {
		if (label.toLocaleLowerCase().includes(string)) return true;

		// check if a group as the filter string as label
		const groupOptions = list.filter((group) =>
			group.label.toLocaleLowerCase().includes(string)
		);

		if (groupOptions) {
			for (const groupOption of groupOptions) {
				// Check if current option is in group
				const option =
					groupOption.options !== undefined
						? groupOption.options.find((opt) => opt.value === value)
						: "";

				if (option) {
					return true;
				}
			}
		}
		return false;
	};

	useEffect(() => {
		if (checkIfArray(props.list)) {
			if (props.list.length !== 0) {
				const tempList = props.list;
				const restructured_list = tempList.map((v) => {
					if (typeof v?.options !== "undefined") {
						const tempClient = v?.options[0]?.solo === 1 ? "" : v?.label;
						const tempSites = v?.options.map((y) => {
							return {
								...y,
								label: y.operation_status === 2 ? `${y.label} (MSA)` : y.label,
							};
						});

						return { label: tempClient, options: tempSites };
					} else {
						return v;
					}
				});
				setList(restructured_list);
				setVal(null);
			}
		}
	}, [props.list]);

	useEffect(() => {
		if (list.length > 0) {
			if (checkIfObjectHasKeys(props.defaultVal)) {
				if (
					props.defaultVal?.value !== undefined ||
					props.defaultVal?.label !== undefined
				) {
					const defaultValue = list.filter(
						(v) => v.value === props.defaultVal.value
					);
					const defaultLabel = list.filter(
						(v) => v.label === props.defaultVal.label
					);
			
					if (defaultValue.length === 1) setVal(defaultValue[0]);
					else if (defaultLabel.length === 1) setVal(defaultLabel[0]);
				} else if (!checkIfObjectHasKeys(props.defaultVal)) {
					setVal(null);
				}
				setReady(true);
			} else {
				setReady(true);
				setVal(null);
			}	
		}
	}, [props.defaultVal, list]);

	return (
		<Select
			options={list}
			onChange={handleChange}
			styles={selectStyles}
			filterOption={filterOption}
			isLoading={!isReady}
			placeholder={props.text}
			value={val}
			isDisabled={props.isDisable}
		/>
	);
};
